const init = function () {
    let clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    // 设计图尺寸是1920px，这样 *20 之后，1rem 就等于 20px;
    const fontSize = (clientWidth / 1920 * 20);
    document.documentElement.style.fontSize = fontSize + "px";
  };
   
  init();
   
  window.addEventListener("resize", init);
  export default init;